import { useMemo } from "react";
import { Link } from "react-router-dom";
import ComicCard from "@/components/base/ComicCard";
import { comics } from "@/mocks/comics";

export default function LatestList() {
  const latest = useMemo(
    () => [...comics].sort((a, b) => b.updateDate.localeCompare(a.updateDate)).slice(0, 8),
    [],
  );

  return (
    <section className="w-full">
      <div className="mb-4 flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">最新上传</h2>
          <p className="mt-1.5 text-sm text-foreground-600">按上传时间倒序，第一时间获取新资源</p>
        </div>
        <Link
          to="/search"
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-accent-600"
        >
          查看全部
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 xl:grid-cols-4">
        {latest.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}